import React from 'react'
import { PurchaseContext } from '../contexts/PurchaseContext'
import ProductSelect from './ProductSelect';
import SpinnerOverlay from '../../common/components/SpinnerOverlay'

import { useTranslation } from 'react-i18next';

type Props = {
    onAddToCart?: Function,
    addToCartLabel?: string
}

export default function PurchaseWindowCompact(props: Props) {
    const [state, setState] = React.useContext(PurchaseContext);

    const { t } = useTranslation('common');

    const {onAddToCart = showCart, addToCartLabel = t('actions.addToCart')} = props;

    return (
        <div className='row' id="purchase-window">
            <div className="col-12">
                <SpinnerOverlay hidden={!state.loading} message='Loading'>
                <div className="row" style={{minHeight: '450px'}}>
                    <div className='col-12'>
                        <ProductSelect onAddToCart={onAddToCart} addToCartLabel={addToCartLabel} />
                    </div>
                </div>
                </SpinnerOverlay>
            </div>
        </div>
    )
}
